export default { sha: '44bedb8c1fb1a90e456f7783235e73030de85be0', buildNumber: 'undefined' }
